import React from "react";
import BigInput from "../../components/QcDashboard/UI/Input/BigInput";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const QcFieldIdInput = () => {
  const history = useHistory();
  const [value, setValue] = React.useState("");
  const [error, setError] = React.useState("");

  const handleChange = (e) => {
    setValue(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (value === "") {
        setError("Please enter a valid FE ID");
      } else {
        setError("");
        history.push(`/qc-details-v2/${value}`);
      }
    }
  };

  return (
    <MainPageWrapper center={true}>
      <BigInput
        label="Enter FE ID to continue"
        placeholder="Enter FE ID here"
        value={value}
        onChange={(e) => handleChange(e)}
        onKeyDown={handleKeyDown}
        error={error}
      />
    </MainPageWrapper>
  );
};

export const MainPageWrapper = styled.div`
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  max-height: 100%;

  padding: 28px;
  justify-content: ${(props) => (props.center ? "center" : "flex-start")};
  align-items: ${(props) => (props.center ? "center" : "flex-start")};
  flex: 1;
  min-height: calc(100vh - 70px);
`;

export default QcFieldIdInput;
